import { render, staticRenderFns } from "./WebPartFormShopWithProductCalendarDesigner.vue?vue&type=template&id=28757f30&scoped=true&"
import script from "./WebPartFormShopWithProductCalendarDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartFormShopWithProductCalendarDesigner.vue?vue&type=script&lang=js&"
import style0 from "./WebPartFormShopWithProductCalendarDesigner.vue?vue&type=style&index=0&id=28757f30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28757f30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28757f30')) {
      api.createRecord('28757f30', component.options)
    } else {
      api.reload('28757f30', component.options)
    }
    module.hot.accept("./WebPartFormShopWithProductCalendarDesigner.vue?vue&type=template&id=28757f30&scoped=true&", function () {
      api.rerender('28757f30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/WebPartFormShopWithProductCalendarDesigner.vue"
export default component.exports